export default __webpack_public_path__ + "static/media/profile-new.7e5f4631.png";